import { render, staticRenderFns } from "./PassWordRetrieve.vue?vue&type=template&id=2df21986&scoped=true&"
import script from "./PassWordRetrieve.vue?vue&type=script&lang=js&"
export * from "./PassWordRetrieve.vue?vue&type=script&lang=js&"
import style0 from "./PassWordRetrieve.vue?vue&type=style&index=0&id=2df21986&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2df21986",
  null
  
)

export default component.exports